import React, { useContext } from "react";
import { StateManagerContext } from "../widgets/StateManagerContext";
import { ScheduleProgram } from "../Shared/Schedule/Schedule";
import { StateManager } from "../widgets/PartyState";



export type ScheduleColumnDisplayProps = {
    width: number;
    imageHeight: number;
    panelHeight: number;
    slots: number;
    gap: number;
    style: React.CSSProperties;
}


export type ScheduleColumnProps = {
    display: ScheduleColumnDisplayProps
}

type ScheduleBoxProps = {
    name: string;
    description: string;
    image: string;
    panelHeight: number;
    imageHeight: number;
    width: number;
    borderRadius: number;
    category: string;
    categoryColor: string;
    liveNow: boolean;
    gridColumn: number;
    gridRow: number;
    channelN: number;
    slotN: number;
    clickFunc(channel: number, slot: number): void
}


const ScheduleBox = ({ name, description, image, panelHeight, imageHeight, width, borderRadius, category, categoryColor, liveNow, gridColumn, gridRow, channelN, slotN, clickFunc }: ScheduleBoxProps): React.JSX.Element => {

    const height = imageHeight + panelHeight;
    const _width = width + "px";
    const _height = height + "px";
    const _imageHeight = imageHeight + "px";
    const _panelHeight = panelHeight + "px";

    const bckColor = liveNow ? "white" : "#333232";
    const titleColor = liveNow ? "black" : "white";
    const descriptionColor = liveNow ? "#615A5A" : "white";



    return (
        <div
            style={{
                minWidth: _width,
                width: _width,
                maxWidth: _width,
                minHeight: _height,
                height: _height,
                maxHeight: _height,
                overflow: "hidden",
                backgroundColor: bckColor,
                borderRadius: borderRadius + "px",
                gridColumn: gridColumn,
                gridRow: gridRow,
                position: "relative"
            }}
            onClick={() => { clickFunc(channelN, slotN); }}
        >
            <img src={image} style={{
                width: _width,
                minWidth: _width,
                minHeight: _imageHeight,
                position: "absolute",
                top: "0px",
                left: "0px",
            }} />
            <div style={{
                minWidth: _width,
                width: _width,
                maxWidth: _width,
                height: _panelHeight,
                minHeight: _panelHeight,
                maxHeight: _panelHeight,
                position: "absolute",
                top: _imageHeight,
                left: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                backgroundColor : bckColor
            }} >
                <span style={{
                    fontSize: "18px",
                    color: titleColor
                }}>{name}</span>
                <span style={{
                    fontSize: "12px",
                    color: descriptionColor,
                }}>{description}</span>
            </div>
            <div style={{
                position: "absolute",
                top: "18px",
                width: _width,
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <div style={{
                    backgroundColor: categoryColor,
                    borderRadius: "25px",
                    height: "17px",
                    minHeight: "17px",
                    maxHeight: "17px",


                }}>
                    <span style={{
                        color: "white",
                        fontSize: "14px",
                        position : "relative",
                        top : "-4px"
                    }}>{category}</span>
                </div>
            </div>
            {
                (liveNow && <div style={{
                    width: "97px",
                    minWidth: "97px",
                    maxWidth: "97px",
                    height: "21px",
                    minHeight: "21px",
                    maxHeight: "21px",
                    position: "absolute",
                    top: (imageHeight - 10) + "px",
                    left: (width * 0.5 - 48) + "px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    boxShadow: "0px 4px 4px black",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                    alignItems: "center"
                }}>
                    <div style={{
                        backgroundColor: "#92CA36",
                        borderRadius: "6.5px",
                        minWidth: "13px",
                        width: "13px",
                        minHeight: "13px",
                        height: "13px",
                        position: "absolute",
                        left: "10px",
                        top: "4px"
                    }}>
                       

                    </div>
                    <span style={{
                            fontSize: "12px",
                            color : "black",
                            paddingLeft : "15px",
                            paddingTop : "2px"
                        }}>LIVE NOW</span>

                </div>)
            }
        </div>
    );

    //<Typography sx={{ fontSize: "14px", paddingTop: "5px", paddingLeft: "10px", paddingRight: "10px", textAlign: "left", color: descriptionColor, fontWeight: bold ? "bold" : "normal" }}>{description}</Typography>
}



export const ScheduleColumn = ({ display }: ScheduleColumnProps): React.JSX.Element => {
    const stateManager = useContext(StateManagerContext);
    const schedulePrograms = stateManager.context().schedule;
    const outerDivRef = React.useRef<HTMLDivElement|null> (null);
    const notifyId = React.useRef<number>(-1);
    const [rc,setRC] = React.useState<number>(0);

    const updateSchedule = (state : StateManager) => {
        if(outerDivRef.current !== null)
            outerDivRef.current.style.opacity = '0.0';
        window.setInterval(()=>{
            setRC(rc+1);
            if(outerDivRef.current !== null)
                outerDivRef.current.style.opacity = '1.0';
        }, 1000)
    }

    if(notifyId.current === -1)
    {
        const nid = Math.random();
        stateManager.addNotifyContextUpdateFunction(nid,updateSchedule);
        notifyId.current = nid;
    }

    React.useEffect(() => {
            
            outerDivRef.current = document.getElementById("ScheduleDivOuter") as HTMLDivElement;
            return () => {if(notifyId.current !== -1) stateManager.removeNotifyMainUpdateFunction(notifyId.current);}
    
            /*if (!initTimer.current) {
                initTimer.current = true;
                window.setInterval(runUserCounts, 60000);
            }*/
        })


    
    const height = display.slots * (display.imageHeight + display.panelHeight) + (display.slots - 1) * display.gap;

    //const now = new Date(Date.now());
    //const hour = now.getHours();
    //const min = Math.floor(now.getMinutes() / 30);


    const clickFunc = (channel: number, slot: number) => { console.log("Slot Click (" + channel + "," + slot + ");") };

    const styleO : React.CSSProperties = {
        height: height + "px",
        minWidth: display.width + "px",
        display: "flex",
        flexDirection: "column",
        gap: display.gap + "px",
        opacity : 1.0,
        transition: 'opacity 1s', transitionTimingFunction: 'ease-in-out'

    }

    Object.assign(styleO, display.style);

    const toDisplay = schedulePrograms.slice(0,display.slots);

    return (
        <div style={styleO} id="ScheduleDivOuter">
            {
                toDisplay.map((value: ScheduleProgram, index: number) => {

                    /*const h = min === 0 ? hour + Math.round(index / 2 - 0.5) : hour + Math.round(index / 2);
                    const _m = min === 0 ? index % 2 : 1 - (index % 2);
                    const m = _m ===0 ? "00" : "30";
                    const h2 = _m === 0 ? h : h+1;
                    const m2 = _m === 0 ? "30" : "00"; 
                    const d = (h < 10 ? "0" : "") + h + ":" + m + " - " +  (h2 < 10 ? "0" : "") + h2 + ":" + m2;*/



                    const props: ScheduleBoxProps = {
                        name: value.name,
                        description: value.description,
                        image: value.image,
                        panelHeight: display.panelHeight,
                        imageHeight: display.imageHeight,
                        width: display.width,
                        borderRadius: 15,
                        category: value.category,
                        categoryColor: value.categoryColor,
                        liveNow: index === 0,
                        gridColumn: 0,
                        gridRow: 0,
                        channelN: 0,
                        slotN: index,
                        clickFunc: clickFunc
                    };

                    return (<ScheduleBox key={'ScheduleBox' + index} {...props} />);

                })
            }

        </div>
    );
}
